import React from "react";

/** Parse common video URL formats and return a normalized `{kind, id, src}`.
 *  Supported:
 *   - YouTube: youtube.com/watch?v=..., youtu.be/..., youtube.com/shorts/...
 *   - Vimeo: vimeo.com/12345
 *   - Direct MP4/WebM/MOV file (any URL ending in a video extension)
 */
function parseVideo(url) {
  if (!url) return null;
  const u = url.trim();
  // YouTube
  const yt =
    u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i);
  if (yt) return { kind: "youtube", id: yt[1], src: `https://www.youtube.com/embed/${yt[1]}?rel=0&modestbranding=1` };
  // Vimeo
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vm) return { kind: "vimeo", id: vm[1], src: `https://player.vimeo.com/video/${vm[1]}?byline=0&title=0` };
  // Direct video file
  if (/\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(u)) return { kind: "file", src: u };
  return null;
}

export function isPlayableVideoUrl(url) {
  return parseVideo(url) !== null;
}

export default function ProductMedia({ videoUrl, poster, alt }) {
  const v = parseVideo(videoUrl);
  if (!v) return null;
  if (v.kind === "file") {
    return (
      <video
        className="w-full h-full object-cover"
        src={v.src}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        controls
        data-testid="product-hero-video"
      />
    );
  }
  return (
    <iframe
      className="w-full h-full"
      src={v.src}
      title={alt || "Product video"}
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      data-testid="product-hero-video"
    />
  );
}
